import React, { useEffect, useState } from 'react'
import {
  Form,
  Input,
  Select,
  Tag,
  Button,
  Space,
  Divider,
  DatePicker,
  Cascader,
  Col,
  Row,
} from 'antd'
import { FieldTypeEnum } from '@/config/enum'
import SearchInput from '../components/SearchInput'
import SearchSelect from '../components/SearchSelect'
import SearchDateTime from '../components/SearchDateTime'
import SearchDateRange from '../components/SearchDateRange'
import SearchCascader from '../components/SearchCascader'
import SearchTreeSelect from '../components/SearchTreeSelect'
import SearchInputNumberRange from '../components/SearchInputNumberRange'
import SearchAutocomplete from '../components/SearchAutocomplete'
import styles from '../index.module.less'
import { ConfigItem } from '..'
import { LayoutEnum, LayoutEnumType } from '../enum'

interface PayLoad {
  layout: string,
  filterInputSchema: ConfigItem[]
}

export default function useRender() {
  // 渲染搜索项
  const renderSearchField = (field, { layout, filterInputSchema }: PayLoad) => {
    const { label, initialValue, name, componentType, defaultValue, multiple } = field
    const width = layout === LayoutEnum.HORIZONTAL ? field.width : '100%'
    const fieldProps = { ...field, width, layout }
    // console.log('renderSearchField field: ', {field,fieldProps})

    if (componentType === FieldTypeEnum.INPUT) {
      return (
        <Form.Item name={name}>
          <SearchInput field={fieldProps} />
        </Form.Item>
      )
    }
    if (componentType === FieldTypeEnum.SELECT || componentType === FieldTypeEnum.SELECT_MULTI) {
      return (
        <Form.Item name={name}>
          <SearchSelect field={fieldProps} />
        </Form.Item>
      )
    }
    if (componentType === FieldTypeEnum.SELECT_MULTI) {
      return (
        <Form.Item name={name}>
          <SearchSelect field={fieldProps} />
        </Form.Item>
      )
    }
    if (componentType === FieldTypeEnum.DATETIME) {
      return (
        <Form.Item name={name}>
          <SearchDateTime field={fieldProps} />
        </Form.Item>
      )
    }
    if (componentType === FieldTypeEnum.DATETIME_RANGE) {
      return (
        <Form.Item name={name}>
          <SearchDateRange field={fieldProps} />
        </Form.Item>
      )
    }
    // 级联选择器
    if (componentType === FieldTypeEnum.CASCADER) {
      return (
        <Form.Item name={name}>
          <SearchCascader field={fieldProps} />
        </Form.Item>
      )
    }
    if (componentType === FieldTypeEnum.TREESELECT) {
      return (
        <Form.Item name={name}>
          <SearchTreeSelect field={fieldProps} />
        </Form.Item>
      )
    }
    if (componentType === FieldTypeEnum.INPUT_NUMBER_RANGE) {
      return (
        <Form.Item name={name}>
          <SearchInputNumberRange field={fieldProps} />
        </Form.Item>
      )
    }
    if (componentType === FieldTypeEnum.AUTOCOMPLETE) {
      return (
        <Form.Item name={name}>
          <SearchAutocomplete field={fieldProps} />
        </Form.Item>
      )
    }
    console.log('componentType: ',name, componentType)
    return <div>{name} {componentType}</div>
  }

  // 渲染操作项
  const renderOp = op => {
    const { label, type, componentType, children, key } = op
    return (
      <div className={styles.actionItem} key={op.key}>
        {children}
      </div>
    )
  }

  return {
    renderSearchField,
    renderOp,
  }
}
